var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22876",
    "data-name": "Group 22876",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2370",
    "data-name": "Line 2370",
    y2: 8.086,
    transform: "translate(4.227 1.711)",
    fill: "none",
    stroke: "#1c9f00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2371",
    "data-name": "Line 2371",
    y2: 8.086,
    transform: "translate(9.618 4.406) rotate(90)",
    fill: "none",
    stroke: "#1c9f00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4418",
    "data-name": "Rectangle 4418",
    width: 12,
    height: 12,
    rx: 2,
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#1c9f00",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcelIcon);
export default __webpack_public_path__ + "static/media/download_excel_icon.663dfbaa3bf56e0e4ce86d888c739e5c.svg";
export { ForwardRef as ReactComponent };